export * from "./ClinicsMap";
export * from "./ClinicsMap.types";
